export default __webpack_public_path__ + "static/equilibre_poster_video-251725109cd1b63686c23d4797487cfc.png";